import { useMemo } from 'react';
import { type CameraSlice, createStoreHooks } from '../../../../canvas/core';
import {
  createSelectDocumentLayout,
  type PageLayoutSlice,
  useDocumentCanvasContext,
} from '../../../core';

type DebugCenterLineDeps = CameraSlice & PageLayoutSlice;

const { useStore } = createStoreHooks<DebugCenterLineDeps>();

export const DebugCenterLine = () => {
  const { getEffectiveDimensions } = useDocumentCanvasContext();
  const selectDocumentLayout = useMemo(
    () => createSelectDocumentLayout(getEffectiveDimensions),
    [getEffectiveDimensions]
  );
  const { pageLayouts, contentWidth, contentHeight } =
    useStore(selectDocumentLayout);

  if (pageLayouts.length === 0) {
    return null;
  }

  // Content center X - we're already in content coordinate space
  const contentCenterX = contentWidth / 2;

  return (
    <line
      x1={contentCenterX}
      y1={0}
      x2={contentCenterX}
      y2={contentHeight}
      stroke="red"
      strokeWidth={2}
      strokeDasharray="10 5"
      vectorEffect="non-scaling-stroke"
      style={{ pointerEvents: 'none' }}
    />
  );
};
